import React from "react";

import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Collapse, ListItemText, List, ListItem, Typography } from "@mui/material";

interface IProps {
  accounts: string;
}
const E2TAccountIDsList = ({ accounts }: IProps): React.ReactElement => {
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  const accountsList = accounts.split(", ");
  if (accountsList.length > 1) {
    return (
      <List component="nav" sx={{ width: "100%", maxWidth: "280px", padding: 0 }}>
        <ListItem onClick={handleClick} sx={{ paddingTop: "2px", paddingBottom: "2px" }}>
          <ListItemText primary={accountsList[0]} data-test="latest-e2t-account" />
          {open ? (
            <ExpandLess />
          ) : (
            <Typography display="flex" alignItems="center">
              <ExpandMore /> <span data-test="expand-more">+{accountsList.length - 1}</span>
            </Typography>
          )}
        </ListItem>

        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {accountsList.slice(1).map((a) => (
              <ListItem key={a}>
                <ListItemText primary={a} />
              </ListItem>
            ))}
          </List>
        </Collapse>
      </List>
    );
  }
  return (
    <List component="div" disablePadding>
      <ListItem>
        <ListItemText primary={accountsList} />
      </ListItem>
    </List>
  );
};

export default E2TAccountIDsList;
